import React from 'react'

const Heading2 = ({t1,t2,t3,t4,color}) => {
  return (
    <div style={{background:color,color:"white"}} className="h-8 pb-[15px] font-poppins w-full bg-violet-200 rounded-full flex pr-12 items-center mt-7 font-semibold text-xl">
        <div className="flex-1 ml-16 justify-start">{t1}</div>
        <div className="flex-1 ml-28 justify-center">{t2}</div>
        <div className="flex-1 ml-28 justify-end">{t3}</div>
    </div>
  )
}

export default Heading2

export const Heading201 = ({t1,t2,t3,t4,color}) => {
  return (
    <div  style={{background:color,color:"white"}} className="h-8 font-poppins w-full bg-violet-200 rounded-full flex pr-12 items-center mt-7 font-semibold text-xl">
        <div className="flex-1 ml-16 justify-start">{t1}</div>
        <div className="flex-1 ml-28 justify-center">{t2}</div>
        <div className="flex-1 ml-28 justify-end">{t3}</div>
    </div>
  )
}

